import { create } from 'zustand';
import type {
  ProvisioningTemplate,
  WifiInfo,
  EapProfile,
} from '../utils/provisioning-template-types';

export type ProvisioningTemplatesDialogType =
  | 'addTemplate'
  | 'editTemplate'
  | 'addWifi'
  | 'editWifi'
  // 802.1X — push a saved Wi-Fi profile to a fleet of devices
  | 'pushEnterpriseWifi'
  // EapProfile (Step 8) — add + edit dialogs for the new 802.1X Profiles tab
  | 'addEapProfile'
  | 'editEapProfile'
  | null;

interface DialogContext {
  template?: ProvisioningTemplate;
  wifiInfo?: WifiInfo;
  eapProfile?: EapProfile;
}

interface ProvisioningTemplatesDialogState {
  activeDialog: ProvisioningTemplatesDialogType;
  dialogContext: DialogContext;
  openDialog: (dialog: ProvisioningTemplatesDialogType, context?: DialogContext) => void;
  closeDialog: () => void;
}

export const useProvisioningTemplatesDialogStore = create<ProvisioningTemplatesDialogState>(
  (set) => ({
    activeDialog: null,
    dialogContext: {},
    openDialog: (activeDialog, dialogContext = {}) => set({ activeDialog, dialogContext }),
    closeDialog: () => set({ activeDialog: null, dialogContext: {} }),
  }),
);
